let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__menuBurger")
let overlay = document.querySelector(".header__overlayBg")

//オーバーレイ

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    if (header.classList.contains("is-on")) {
        document.documentElement.style.overflowY = "hidden"
    } else {
        document.documentElement.style.overflowY = "auto"
    }
})

overlay.addEventListener("click", () => {
    header.classList.remove("is-on");
    document.documentElement.style.overflowY = "auto"
})

//header__list 縮小

window.addEventListener("scroll", () => {
    isTop()
})

function isTop() {
    if (window.scrollY == 0) {
        header.classList.remove("notTop")
    } else {
        header.classList.add("notTop")
    }
}
isTop()